import {User} from 'components/customer/Auth/store/userSlice';
import {JobRedirectEnum} from 'components/manufacturer/Preferences/entity/Preferences';
import {BaseConfig} from 'config';
import Excel from 'shared/Excel';

const config = BaseConfig.USER_CUSTOMER;
export const JobRedirectMap = new Map([
    [
        JobRedirectEnum.PRODUCT,
        {
            path: 'product',
            isVisible: config.jobMenu.find((menu) => menu.id === 'add_product')
                ?.isVisible,
        },
    ],
    [
        JobRedirectEnum.FAVOURITES,
        {
            path: 'favourites',
            isVisible: config.jobMenu.find(
                (menu) => menu.id === 'favourite_products'
            )?.isVisible,
        },
    ],
    [
        JobRedirectEnum.SUNDRIES,
        {
            path: 'hardware',
            isVisible: config.jobMenu.find((menu) => menu.id === 'sundry')
                ?.isVisible,
        },
    ],
    [
        JobRedirectEnum.LAYOUT,
        {
            path: 'layout',
            isVisible: config.jobMenu.find((menu) => menu.id === 'tdld')
                ?.isVisible,
        },
    ],
    [
        JobRedirectEnum.DETAILED_CART,
        {
            path: 'dashboard',
            isVisible: true,
        },
    ],
    [
        JobRedirectEnum.QFP,
        {
            path: 'quick-flat-product',
            isVisible: config.jobMenu.find((menu) => menu.id === 'qfp')
                ?.isVisible,
        },
    ],
    [
        JobRedirectEnum.ROOM_PLANNER,
        {
            path: 'room-planner',
            isVisible: config.jobMenu.find((menu) => menu.id == 'room-planner')
                ?.isVisible,
        },
    ],
]);

export const getCreateJobRedirect = (
    userProfile: Partial<User>,
    jobId: number,
    roomId?: number | string
) => {
    const {createJobLandingPage, isBenchtopAvailable} = userProfile;

    if (typeof roomId === 'undefined' || roomId === '') {
        return `/v2/job/${jobId}/dashboard`;
    }

    if (createJobLandingPage != undefined) {
        if (
            createJobLandingPage === JobRedirectEnum.BENCHTOP &&
            isBenchtopAvailable
        ) {
            return `/v2/job/${jobId}/benchtop-module`;
        }

        if (
            createJobLandingPage !== JobRedirectEnum.BENCHTOP &&
            createJobLandingPage in JobRedirectEnum
        ) {
            const redirectData = JobRedirectMap.get(createJobLandingPage);

            if (redirectData) {
                const {path, isVisible = false} = redirectData;
                const moduleAvailable =
                    typeof isVisible !== 'boolean'
                        ? Excel.calculate(isVisible, {...userProfile})
                        : isVisible;

                if (moduleAvailable) {
                    if (
                        [
                            JobRedirectEnum.SUNDRIES,
                            JobRedirectEnum.DETAILED_CART,
                            JobRedirectEnum.BENCHTOP,
                        ].includes(createJobLandingPage) &&
                        moduleAvailable
                    ) {
                        return `/v2/job/${jobId}/${path}`;
                    }

                    return `/v2/job/${jobId}/room/${roomId}/${path}`;
                }
            }
        }
    }

    return `/v2/job/${jobId}/room/${roomId}/dashboard`;
};
